import React, { useState, useEffect } from "react";
import Header from "../../Header/Header";
import Select from "react-select";

import { privateRequest } from "../../commonApi/CommonApi";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

function Coupons() {
  const [GroupName, setGroupName] = useState("");
  const [parentCategory, setParentCategoryGroups] = useState([]);
  const [gettservice, setGettService] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [GroupStatus, setStatus] = useState("");
  const [editItemId, setEditItemId] = useState(null);
  const [couponType, setCouponType] = useState(null);

  const navigate = useNavigate();
  const getCoupons = async () => {
    try {
      const response = await privateRequest.get(`coupons/getAllCoupon`);
      setGettService(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getParentCategory = async () => {
    try {
      const response = await privateRequest.get(
        `ParentCategory/Parentcategory`
      );
      setParentCategoryGroups(response?.data?.Data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getCoupons();
    getParentCategory();
  }, []);

  const deleteCoupon = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this Coupon!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `coupons/DeleteCoupon/${_id}`
        );
        getCoupons();
        Swal.fire("Deleted!", "Your Coupon has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your Coupon deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete Coupon.", "error");
    }
  };

  return (
    <>
      {gettservice.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Coupons</span>
                    </p>

                    <Link
                      to="/addcoupons"
                      className="btn btn-primary btn-sm ml-auto"
                      data-toggle="modal"
                      data-target="#childModal"
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </Link>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card">
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm"
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">SN</th>
                            <th scope="col">Code</th>
                            <th scope="col">Type</th>
                            <th scope="col">Amount</th>
                            <th scope="col " style={{ color: "red" }}>
                              No. of time coupon used
                            </th>
                            <th scope="col">No. of time coupon can be used</th>
                            <th className="text-nowrap" scope="col">
                              User Limit
                            </th>
                            <th scope="col">Expire Date</th>
                            <th scope="col">Status</th>
                            <th scope="col">Created</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {gettservice?.map((item, index) => (
                            <tr key={index}>
                              <td className="align-center">{index + 1}</td>

                              <td className="align-center">
                                {item?.couponCode}
                              </td>
                              <td className="align-center">
                                {item?.couponType}
                              </td>
                              <td className="align-center">
                                {item?.couponType == "Fixed" || "FirstTime"
                                  ? "₹ " + item?.couponValue
                                  : item?.couponValue + " %"}
                              </td>
                              <td className="align-center">
                                {item?.usageCount}
                              </td>
                              <td className="align-center">
                                {item?.couponUsesLimit}
                              </td>
                              <td className="align-center">
                                {item?.userUsesLimit}
                              </td>
                              <td>
                                <p className="mb-0">
                                  {new Date(item.expiryDate).toLocaleDateString(
                                    "en-US",
                                    {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    }
                                  )}
                                </p>
                              </td>

                              <td>
                                <span
                                  className={`badge ${
                                    item.Status
                                      ? "badge-primary"
                                      : "badge-danger"
                                  }`}
                                >
                                  {item.Status ? "Active" : "Inactive"}
                                </span>
                              </td>
                              <td className="align-center">
                                <p className="mb-0">{item.createdBy?.name}</p>
                                <p className="mb-0">
                                  {new Date(item.createdAt).toLocaleDateString(
                                    "en-US",
                                    {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    }
                                  )}
                                </p>
                              </td>
                              <td className="align-center">
                                <div className="btn-group">
                                  <button
                                    onClick={() => {
                                      navigate("/editcoupons", { state: item });
                                    }}
                                    className="btn btn-primary btn-sm"
                                    data-toggle="modal"
                                    data-target="#childModal"
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>

                                  <button
                                    onClick={() => deleteCoupon(item?._id)}
                                    className="btn btn-danger btn-sm"
                                    data-toggle="modal"
                                    data-target="#childModal"
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Coupons;
